//@ts-nocheck
import {
  ComponentPublicInstance,
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  PropType,
  reactive,
  ref,
  watch
} from "vue";
import {db_assessment} from "./_data";
import {createApp} from "vue/dist/vue.esm-bundler.js";
import {Navigator as NavigatorAPI} from "../../api/Navigator";
import {Analytics} from "../../api/Analytics";
import {EventName} from "../../enums/analytics/EventName";
import {UnipageNavigatorAssessmentSource} from "../../enums/UnipageNavigatorAssessmentSource";
import {preventPopupShowingById} from "../../components/Popup";

export const AssessmentComponent = defineComponent({
  props: {
    mode: {
      type: String,
      default: 'popup',
    },
    initialQuestionId: {
      type: String,
      default: null,
    },
    source: {
      type: String as PropType<UnipageNavigatorAssessmentSource>,
      required: true,
    }
  },
  emits: ['complete'],
  directives: {
    indeterminate(el, binding) {
      el.indeterminate = binding.value;
    }
  },
  template: `
        <div class="assessment-container" ref="questionRef" :class="{'embed-mode': mode === 'embed'}" data-ga-event="x_impression" :data-ga-category="impressionGACategory">
            <div class="quiz-container">
                <div :class="'border-0 position-relative' + (isUnipagePopup ? '' : ' card quiz-card shadow-sm')">
                    <div class="row g-0" :style="(isUnipagePopup ? '' :'border-top-left-radius: 24px; border-top-right-radius: 24px;') + 'overflow: hidden;'">
                        <div :class="isUnipagePopup ? '' : 'col-12 p-4 p-md-5'">
                            <div v-if="questions[currentQuestionIndex]" class="question-section">

                                <h2 class="h3 fw-bold mb-3" :style="isUnipagePopup ? 'padding-right: 54px;' : ''">{{ questions[currentQuestionIndex].title }}</h2>
                                <p class="text-secondary mb-4">{{ questions[currentQuestionIndex].subtitle }}</p>

                                <div v-if="questions[currentQuestionIndex].id === 'lang_level' && currentLang" class="alert-custom mb-4">
                                    <h3 class="mt-0 mb-0">{{ getLangName(currentLang) }}</h3>
                                </div>

                                <div v-if="questions[currentQuestionIndex].id !== 'regions'" 
                                     :class="['options-grid', 'row', 'g-1', questions[currentQuestionIndex].id === 'langs' ? 'unipage-navigator-assessment__language-list' : '']">
                                    <template v-for="(option, idx) in sortedOptions" :key="option.value">
                                        <div v-show="questions[currentQuestionIndex].id !== 'langs' || showAllLangs || idx < 6" 
                                             :class="questions[currentQuestionIndex].id === 'residencies' ? 'col-6' : 'col-12'">
                                            <div class="option-card rounded p-2 px-3 d-flex align-items-start h-100"
                                                 :class="{ 'selected': isOptionSelected(option.value) }"
                                                 @click="selectOption(option.value)">
                                                <div class="custom-radio mt-1" :class="{ 'checked': isOptionSelected(option.value), 'checkbox': questions[currentQuestionIndex].multiple }"></div>
                                                <div class="ms-2 flex-grow-1">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <div class="option-label fw-bold">
                                                            {{ option.label }}
                                                        </div>
                                                        <div v-if="questions[currentQuestionIndex].id === 'langs'" class="ms-auto small text-secondary">
                                                            Вариантов <span class="fw-bold text-primary px-2 py-1 rounded-pill bg-primary bg-opacity-10">{{ option.count }}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="option.description" class="option-desc small text-secondary mt-1">{{ option.description }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <div v-if="questions[currentQuestionIndex].id === 'langs' && !showAllLangs" class="col-12 mt-2">
                                        <button @click="showAllLangs = true" class="button button_secondary w-100 py-3 rounded text-start d-flex align-items-center justify-content-center border-dashed">
                                            <span class="fw-bold text-secondary">Больше языков</span>
                                        </button>
                                    </div>
                                </div>

                                <div v-else class="options-grid row g-1">
                                    <div class="col-12">
                                        <div class="option-card rounded p-3 d-flex align-items-center"
                                             :class="{ 'selected': answers.regions.length === 0 }"
                                             @click="toggleRegion(null)">
                                            <div class="custom-radio checkbox" :class="{ 'checked': answers.regions.length === 0 }"></div>
                                            <div class="ms-3 fw-bold">Все варианты</div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="option-card rounded p-3 d-flex align-items-start"
                                             :class="{ 'selected': answers.regions.includes('anglo') }"
                                             @click="toggleRegion('anglo')">
                                            <div class="custom-radio checkbox mt-1" :class="{ 'checked': answers.regions.includes('anglo') }"></div>
                                            <div class="ms-3">
                                                <div class="fw-bold">Англоговорящие страны</div>
                                                <div class="small text-secondary">США, Канада, Великобритания, Ирландия, Австралия, НЗ и др.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="accordion" id="accordionEurope">
                                            <div class="accordion-item border-0">
                                                <div class="accordion-header d-flex align-items-center option-card rounded p-1 pe-2" :class="{ 'selected': isParentChecked('europe') || isIndeterminate('europe') }">
                                                    <div class="p-2 ps-3 d-flex align-items-center" @click.stop="toggleParent('europe')">
                                                        <div class="custom-radio checkbox" :class="{ 'checked': isParentChecked('europe'), 'indeterminate': isIndeterminate('europe') }">
                                                            <input type="checkbox" class="d-none" v-indeterminate="isIndeterminate('europe')">
                                                        </div>
                                                    </div>
                                                    <button class="accordion-button p-2 pe-3 ps-1 flex-grow-1 bg-transparent shadow-none d-flex align-items-center" :class="{ collapsed: !isGroupOpen('europe') }" type="button" @click="toggleGroup('europe')">
                                                        <span class="ms-2 flex-grow-1">
                                                            <span class="fw-bold d-block">Европа</span>
                                                            <span class="small text-secondary fw-normal d-block">Западная, Скандинавия, Страны балтии, Восточная, Южная Европа</span>
                                                        </span>
                                                    </button>
                                                </div>
                                                <div class="accordion-collapse collapse" :class="{ show: isGroupOpen('europe') }">
                                                    <div class="accordion-body ps-4 pe-0 py-2">
                                                        <div class="row g-1">
                                                            <div class="col-12" v-for="sub in europeSubRegions" :key="sub.id">
                                                                <div class="option-card rounded p-2 px-3 d-flex align-items-start" :class="{ 'selected': answers.regions.includes(sub.id) }" @click="toggleRegion(sub.id)">
                                                                    <div class="custom-radio checkbox mt-1" :class="{ 'checked': answers.regions.includes(sub.id) }"></div>
                                                                    <div class="ms-3">
                                                                        <div class="fw-bold">{{ sub.label }}</div>
                                                                        <div class="small text-secondary">{{ sub.desc }}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="accordion" id="accordionAsia">
                                            <div class="accordion-item border-0">
                                                <div class="accordion-header d-flex align-items-center option-card rounded p-1 pe-2" :class="{ 'selected': isParentChecked('asia') || isIndeterminate('asia') }">
                                                    <div class="p-2 ps-3 d-flex align-items-center" @click.stop="toggleParent('asia')">
                                                        <div class="custom-radio checkbox" :class="{ 'checked': isParentChecked('asia'), 'indeterminate': isIndeterminate('asia') }">
                                                            <input type="checkbox" class="d-none" v-indeterminate="isIndeterminate('asia')">
                                                        </div>
                                                    </div>
                                                    <button class="accordion-button p-2 pe-3 ps-1 flex-grow-1 bg-transparent shadow-none d-flex align-items-center" :class="{ collapsed: !isGroupOpen('asia') }" type="button" @click="toggleGroup('asia')">
                                                        <span class="ms-2 flex-grow-1">
                                                            <span class="fw-bold d-block">Азия</span>
                                                            <span class="small text-secondary fw-normal d-block">Глобальные хабы, Развивающиеся рынки</span>
                                                        </span>
                                                    </button>
                                                </div>
                                                <div class="accordion-collapse collapse" :class="{ show: isGroupOpen('asia') }">
                                                    <div class="accordion-body ps-4 pe-0 py-2">
                                                        <div class="row g-1">
                                                            <div class="col-12" v-for="sub in asiaSubRegions" :key="sub.id">
                                                                <div class="option-card rounded p-2 px-3 d-flex align-items-start" :class="{ 'selected': answers.regions.includes(sub.id) }" @click="toggleRegion(sub.id)">
                                                                    <div class="custom-radio checkbox mt-1" :class="{ 'checked': answers.regions.includes(sub.id) }"></div>
                                                                    <div class="ms-3">
                                                                        <div class="fw-bold">{{ sub.label }}</div>
                                                                        <div class="small text-secondary">{{ sub.desc }}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="option-card rounded p-3 d-flex align-items-start"
                                             :class="{ 'selected': answers.regions.includes('cis') }"
                                             @click="toggleRegion('cis')">
                                            <div class="custom-radio checkbox mt-1" :class="{ 'checked': answers.regions.includes('cis') }"></div>
                                            <div class="ms-3">
                                                <div class="fw-bold">СНГ и соседи</div>
                                                <div class="small text-secondary">Россия, Казахстан, Грузия, Армения и др.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="option-card rounded p-3 d-flex align-items-start"
                                             :class="{ 'selected': answers.regions.includes('latam') }"
                                             @click="toggleRegion('latam')">
                                            <div class="custom-radio checkbox mt-1" :class="{ 'checked': answers.regions.includes('latam') }"></div>
                                            <div class="ms-3">
                                                <div class="fw-bold">Латинская Америка</div>
                                                <div class="small text-secondary">Бразилия, Аргентина, Мексика и др.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="option-card rounded p-3 d-flex align-items-start"
                                             :class="{ 'selected': answers.regions.includes('mena') }"
                                             @click="toggleRegion('mena')">
                                            <div class="custom-radio checkbox mt-1" :class="{ 'checked': answers.regions.includes('mena') }"></div>
                                            <div class="ms-3">
                                                <div class="fw-bold">Ближний Восток</div>
                                                <div class="small text-secondary">ОАЭ, Турция, Израиль и др.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="option-card rounded p-3 d-flex align-items-start"
                                             :class="{ 'selected': answers.regions.includes('other') }"
                                             @click="toggleRegion('other')">
                                            <div class="custom-radio checkbox mt-1" :class="{ 'checked': answers.regions.includes('other') }"></div>
                                            <div class="ms-3">
                                                <div class="fw-bold">Остальной мир</div>
                                                <div class="small text-secondary">ЮАР, Индия и другие страны.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Navigation -->
                    <div v-if="questions[currentQuestionIndex]" :class="isUnipagePopup ? 'pt-3' : 'sticky-bottom bg-white py-3 px-4 px-md-5 border-top'" style="z-index: 1020; bottom: 0; border-bottom-left-radius: 24px; border-bottom-right-radius: 24px;">
                        <div class="d-flex align-items-center justify-content-between">
                            <button @click="prevQuestion" 
                                    class="button button_tertiary button_size_s text-decoration-none p-0"
                                    :disabled="currentQuestionIndex === 0">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="me-1">
                                    <path d="M19 12H5M12 19l-7-7 7-7"/>
                                </svg>
                                Назад
                            </button>
                            
                            <div class="d-flex align-items-center flex-grow-1 mx-4">
                                <div class="progress flex-grow-1" style="height: 6px;">
                                    <div class="progress-bar bg-primary" :style="{ width: progressPercentage + '%' }"></div>
                                </div>
                                <span class="ms-3 small fw-bold text-secondary">{{ currentStep }}/{{ totalSteps }}</span>
                            </div>

                            <button v-if="currentQuestionIndex < questions.length - 1 || (questions[currentQuestionIndex]?.id === 'lang_level' && currentLangIndex < langLevelQueue.length - 1)" 
                                    @click="nextQuestion" 
                                    class="button button_primary button_inverted button_size_m fw-bold"
                                    :disabled="!isNextEnabled">
                                Далее
                            </button>
                            <button v-else 
                                    @click="completeAssessment" 
                                    class="button button_primary button_inverted button_size_m fw-bold"
                                    :disabled="!isNextEnabled">
                                Посмотреть варианты
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
  setup(props, { emit }) {
    const getStorageKey = () => (window.APP_CONFIG && window.APP_CONFIG.STORAGE_KEY) || 'unipage_assessment_data';
    const getAnalyticsStorageKey = () => (window.APP_CONFIG && window.APP_CONFIG.ANALYTICS_STORAGE_KEY) || 'unipage_assessment_analytics';
    const getScholarshipsUrl = () => (window.APP_CONFIG && window.APP_CONFIG.SCHOLARSHIPS_URL) || 'https://www.unipage.net/ru/scholarships';

    const currentQuestionIndex = ref(0);
    const currentLangIndex = ref(0);
    const langLevelQueue = ref([]);
    const showAllLangs = ref(false);
    const openGroups = ref([]);

    const dataReady = ref(!!(window.ASSESSMENT_QUESTIONS && window.ASSESSMENT_QUESTIONS.length));

    const analytics = reactive([]);
    const questionStartTime = ref(0);

    const isNewSession = ref(true);

    const toggleGroup = (id) => {
      const idx = openGroups.value.indexOf(id);
      if (idx > -1) openGroups.value.splice(idx, 1);
      else openGroups.value.push(id);
    };
    const isGroupOpen = (id) => openGroups.value.includes(id);

    const defaultAnswers = (window.UniPage && window.UniPage.DEFAULT_ANSWERS) || {
      langs: [],
      langLevels: {},
      timeToStart: null,
      gpa: null,
      budget: null,
      regions: [],
      residencies: [],
      favorites: [],
      sortBy: 'default'
    };
    const answers = reactive({ ...defaultAnswers });

    const questionRef = ref<HTMLElement | null>(null);
    let observer: IntersectionObserver | null = null;
    let startTimeSet = false;

    const isUnipagePopup = props.source === UnipageNavigatorAssessmentSource.POPUP;

    const saved = localStorage.getItem(getStorageKey());

    onMounted(() => {
      if (!window.ASSESSMENT_QUESTIONS || !window.ASSESSMENT_QUESTIONS.length) {
        dataReady.value = false;
        try {
          const sharedData = JSON.parse(JSON.stringify(db_assessment));
          Object.assign(window, sharedData);
        } catch (e) {
          console.error("Error loading shared data", e);
        } finally {
          dataReady.value = true;
        }
      }

      if (saved) {
        try {
          const data = JSON.parse(saved);
          Object.assign(answers, data);
          if (answers.langs) {
            langLevelQueue.value = [...answers.langs];
          }
        } catch (e) {
          console.error("Error loading saved data", e);
        }
      }

      if (questionRef.value) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && !startTimeSet) {
                startTimeSet = true;
                setQuestionStartTimeToNow();
                if (observer && questionRef.value) {
                  observer.unobserve(questionRef.value);
                }
              }
            });
          },
          {
            root: null,
            threshold: 0.5, // можно подправить по желанию
          }
        );

        observer.observe(questionRef.value);
      }
    });

    onBeforeUnmount(() => {
      if (observer && questionRef.value) {
        observer.unobserve(questionRef.value);
      }
    });

    const questions = computed(() => {
      if (!dataReady.value) return [];
      return (window.ASSESSMENT_QUESTIONS || []).map(q => {
        let options = window[q.optionsKey] || [];
        if (q.id === 'langs') {
          options = Object.entries(window.LANGUAGES || {}).map(([val, langData]) => ({
            value: val,
            label: (langData && typeof langData === 'object') ? langData.label : langData,
            description: '',
            count: (langData && typeof langData === 'object') ? (langData.count || 0) : 0
          }));
        }
        return { ...q, options };
      });
    });

    watch([questions, () => props.initialQuestionId], ([newQuestions, newId]) => {
      if (newId && newQuestions.length > 0) {
        const index = newQuestions.findIndex(q => q.id === newId);
        if (index !== -1) {
          currentQuestionIndex.value = index;
        }
      }
    }, { immediate: true });

    const currentLang = computed(() => {
      const q = questions.value[currentQuestionIndex.value];
      if (q && q.id === 'lang_level') {
        return langLevelQueue.value[currentLangIndex.value];
      }
      return null;
    });

    const sortedOptions = computed(() => {
      const q = questions.value[currentQuestionIndex.value];
      if (!q) return [];
      if (q.id === 'langs') {
        return [...q.options].sort((a, b) => {
          const aSelected = answers.langs.includes(a.value);
          const bSelected = answers.langs.includes(b.value);

          if (aSelected !== bSelected) {
            return aSelected ? -1 : 1;
          }

          return b.count - a.count;
        });
      }
      return q.options;
    });

    const isNextEnabled = computed(() => {
      const q = questions.value[currentQuestionIndex.value];
      if (!q) return false;
      if (q.id === 'langs') return answers.langs.length > 0;
      if (q.id === 'lang_level') return answers.langLevels[currentLang.value] !== undefined;
      if (q.id === 'regions') return true;
      const val = answers[q.id];
      return Array.isArray(val) ? val.length > 0 : val !== null;
    });

    const currentStep = computed(() => {
      let step = 0;
      if (!questions.value.length) return 0;

      for (let i = 0; i < currentQuestionIndex.value; i++) {
        const q = questions.value[i];
        if (q?.id === 'lang_level') {
          step += Math.max(1, answers.langs.length);
        } else {
          step += 1;
        }
      }
      const currentQ = questions.value[currentQuestionIndex.value];
      if (currentQ?.id === 'lang_level') {
        step += currentLangIndex.value + 1;
      } else {
        step += 1;
      }
      return step;
    });

    const totalSteps = computed(() => {
      if (questions.value.length === 0) return 0;
      return questions.value.reduce((acc, q) => {
        if (q.id === 'lang_level') return acc + Math.max(1, answers.langs.length);
        return acc + 1;
      }, 0);
    });
    const progressPercentage = computed(() => {
      if (totalSteps.value <= 0) return 0;
      return Math.round((currentStep.value / totalSteps.value) * 100);
    });

    const impressionGACategory = computed(() => {
      return `unipage-navigator-assessment-${props.source}${saved === null ? '-initial' : ''}`;
    })

    async function selectOption(value) {
      const q = questions.value[currentQuestionIndex.value];

      if (q.id === 'lang_level') {
        saveAnalytics(`${q.id}_${currentLang.value}`);

        answers.langLevels[currentLang.value] = value;
        if (currentLangIndex.value < langLevelQueue.value.length - 1) {
          currentLangIndex.value++;
        } else {
          currentQuestionIndex.value++;
        }

        await saveAnswers();

        return;
      }

      if (q.multiple) {
        const idx = answers[q.id].indexOf(value);
        if (idx > -1) answers[q.id].splice(idx, 1);
        else answers[q.id].push(value);
      } else {
        answers[q.id] = value;

        await nextQuestion();
      }
    }

    function saveAnalytics(questionId) {
      const alreadySent = analytics.some(a => a.questionId === questionId);

      const now = Date.now();
      const startTimeMs = questionStartTime.value;
      const durationMs = now - questionStartTime.value;
      const endTimeMs = now;

      if (!alreadySent) {
        const analyticsEntry = {
          questionId,
          questionPosition: currentStep.value,
          totalQuestions: totalSteps.value,
          startTimeMs,
          endTimeMs,
          durationMs
        };

        analytics.push(analyticsEntry);

        Analytics.instance().sendEvent(
          EventName.X_CUSTOM,
          `unipage-navigator-assessment-${props.source}${saved === null ? '-initial' : ''}-answer`,
          `${questionId}|${currentStep.value}/${totalSteps.value}|${durationMs}ms`
        );
      }

      setQuestionStartTimeToNow();
    }

    function setQuestionStartTimeToNow() {
      questionStartTime.value = Date.now();
    }

    function isOptionSelected(value) {
      const q = questions.value[currentQuestionIndex.value];
      if (q.id === 'lang_level') return answers.langLevels[currentLang.value] === value;
      const val = answers[q.id];
      return Array.isArray(val) ? val.includes(value) : val === value;
    }

    async function nextQuestion() {
      const q = questions.value[currentQuestionIndex.value];

      if (q.id === 'langs') {
        saveAnalytics(q.id);

        langLevelQueue.value = [...answers.langs];
        currentLangIndex.value = 0;
        currentQuestionIndex.value++;

        void saveAnswers();
      } else if (q.id === 'lang_level' && currentLangIndex.value < langLevelQueue.value.length - 1) {
        currentLangIndex.value++;

        void saveAnswers();
      } else if (currentQuestionIndex.value < questions.value.length - 1) {
        saveAnalytics(q.id);

        currentQuestionIndex.value++;

        void saveAnswers();
      } else {
        await completeAssessment();
      }
    }

    function prevQuestion() {
      const q = questions.value[currentQuestionIndex.value];
      const prevQ = questions.value[currentQuestionIndex.value - 1];

      if (prevQ?.id === 'lang_level' && langLevelQueue.value.length > 0) {
        currentQuestionIndex.value--;
        currentLangIndex.value = langLevelQueue.value.length - 1;
      } else if (q?.id === 'lang_level' && currentLangIndex.value > 0) {
        currentLangIndex.value--;
      } else {
        currentQuestionIndex.value--;
      }

      setQuestionStartTimeToNow();
    }

    async function completeAssessment() {
      saveAnalytics(questions.value[questions.value.length - 1].id);
      await saveAnswers();

      if (props.mode === "embed") {
        if (isUnipagePopup) {
          preventPopupShowingById("unipage-navigator-assessment");
        }

        completeEmbed();
      } else {
        emit('complete', answers);
      }
    }

    const completeEmbed = () => {
      const config = window.APP_CONFIG || {};
      const storageKey = config.STORAGE_KEY || 'unipage_assessment_data';
      const redirectPath = config.ASSESSMENT_REDIRECT_URL || '/ru/navigator';

      localStorage.setItem(storageKey, JSON.stringify(answers));

      const url = new URL(redirectPath, window.location.origin);
      if (props.source) {
        url.searchParams.set('source', props.source);
      }

      window.location.href = url.toString();
    };

    const saveAnswers = async () => {
      await NavigatorAPI.answers(answers, analytics, props.source, !isNewSession.value);

      if (isNewSession.value) {
        isNewSession.value = false;
      }

      if (props.mode === "embed" && !isUnipagePopup) {
        preventPopupShowingById("unipage-navigator-assessment");
      }
    }

    function getLangName(code) {
      if (window.UniPage && window.UniPage.utils && window.UniPage.utils.getLangName) {
        return window.UniPage.utils.getLangName(code);
      }
      const langData = (window.LANGUAGES || {})[code];
      return (langData && typeof langData === 'object') ? langData.label : (langData || code);
    }

    const SUBREGION_CODES = [
      'anglo', 'eur_west', 'eur_scan', 'eur_balt', 'eur_east', 'eur_south',
      'asia_hub', 'asia_em', 'cis', 'latam', 'mena', 'other'
    ];

    const PARENT_GROUPS = {
      europe: ['eur_west', 'eur_scan', 'eur_balt', 'eur_east', 'eur_south'],
      asia: ['asia_hub', 'asia_em']
    };

    function toggleRegion(code) {
      if (code === null) {
        answers.regions = [];
      } else {
        const idx = answers.regions.indexOf(code);
        if (idx > -1) {
          answers.regions.splice(idx, 1);
        } else {
          answers.regions.push(code);
        }

        const allSelected = SUBREGION_CODES.every(c => answers.regions.includes(c));
        if (allSelected) {
          answers.regions = [];
        }
      }
    }

    function toggleParent(parentCode) {
      const children = PARENT_GROUPS[parentCode];
      const allChildrenSelected = children.every(c => answers.regions.includes(c));

      if (allChildrenSelected) {
        children.forEach(c => {
          const idx = answers.regions.indexOf(c);
          if (idx > -1) answers.regions.splice(idx, 1);
        });
      } else {
        children.forEach(c => {
          if (!answers.regions.includes(c)) answers.regions.push(c);
        });
      }

      const allSelected = SUBREGION_CODES.every(c => answers.regions.includes(c));
      if (allSelected) {
        answers.regions = [];
      }
    }

    function isIndeterminate(parentCode) {
      const children = PARENT_GROUPS[parentCode];
      const selectedChildrenCount = (children || []).filter(c => answers.regions.includes(c)).length;
      return selectedChildrenCount > 0 && selectedChildrenCount < (children || []).length;
    }

    function isParentChecked(parentCode) {
      const children = PARENT_GROUPS[parentCode];
      return (children || []).length > 0 && (children || []).every(c => answers.regions.includes(c));
    }

    watch(answers, (newVal) => {
      localStorage.setItem(getStorageKey(), JSON.stringify(newVal));
    }, { deep: true });

    watch(analytics, (newVal) => {
      localStorage.setItem(getAnalyticsStorageKey(), JSON.stringify(newVal));
    }, { deep: true });

    watch(currentQuestionIndex, (newIdx) => {
      const q = questions.value[newIdx];
      if (q && q.id === 'regions') {
        Object.keys(PARENT_GROUPS).forEach(groupKey => {
          const children = PARENT_GROUPS[groupKey];
          const isAnySelected = children.some(c => answers.regions.includes(c));
          if (isAnySelected && !isGroupOpen(groupKey)) {
            toggleGroup(groupKey);
          }
        });
      }
    });

    return {
      questions,
      currentQuestionIndex,
      currentLangIndex,
      answers,
      currentStep,
      totalSteps,
      progressPercentage,
      currentLang,
      sortedOptions,
      isNextEnabled,
      selectOption,
      isOptionSelected,
      nextQuestion,
      prevQuestion,
      getLangName,
      showAllLangs,
      questionRef,
      completeAssessment,
      toggleRegion,
      toggleParent,
      isIndeterminate,
      isParentChecked,
      toggleGroup,
      isGroupOpen,
      europeSubRegions: computed(() => window.EUROPE_SUB_REGIONS),
      asiaSubRegions: computed(() => window.ASIA_SUB_REGIONS),
      isUnipagePopup,
      impressionGACategory,
    };
  }
});

window.AssessmentComponent = AssessmentComponent;

export function initEmbedApp(root: HTMLElement, source: UnipageNavigatorAssessmentSource): ComponentPublicInstance {
  return createApp(AssessmentComponent, {
    mode: 'embed',
    source,
  }).mount(root);
}